export const ProcedureButton = {
  flow: 'x',
  gap: 'Y',
  align: 'center flex-start',
  padding: 'Y Z',
  round: 'Y',
  background: 'teal',
  color: 'ink',
  cursor: 'pointer',
  transition: 'opacity 0.15s ease',
  ':hover': { opacity: '0.85' },
  childrenAs: 'state',

  ProcName: {
    text: (el, s) => s.name || 'Procedure',
    fontSize: 'Z2',
    fontWeight: '600',
    color: 'ink'
  },

  ProcCode: {
    text: (el, s) => s.code || 'D0000',
    fontSize: 'Z2',
    fontWeight: '500',
    color: 'ink',
    opacity: '0.7',
    fontFamily: 'monospace'
  },

  onClick: (el, s) => {
    var tooth = s.root.selectedTooth
    if (!tooth) return
    var toothData = Object.assign({}, s.root.toothData || {})
    var td = Object.assign({}, toothData[tooth] || {})
    var procedures = (td.procedures || []).slice()
    procedures.push({ name: s.name, code: s.code, date: new Date().toISOString().split('T')[0] })
    td.procedures = procedures
    toothData[tooth] = td
    s.root.update({ toothData: toothData })
  }
}
